import { Navigate, Outlet, useLocation } from "react-router-dom";

import { hasToken } from "@/hooks/useAuth";

/** Wraps the authenticated routes; redirects to /login if no token. */
export function ProtectedRoute() {
  const location = useLocation();
  if (!hasToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <Outlet />;
}
